import { withTheme } from "styled-components";
import NumericFact from "./NumericFact";
export default withTheme(NumericFact);
